import Filter from "./Filter";
import Body from "./Body";

const Components = {
  Filter,
  Body,
};

export default Components;
